import React, { useRef } from 'react';
import { BsFunnel } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import {
  Box, Button, Checkbox, Flex, HStack, Icon, IconButton, Popover,
  PopoverArrow,
  PopoverBody, PopoverCloseButton,
  PopoverContent,
  PopoverHeader, PopoverTrigger, Text,
  Tooltip
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FilterLabel from '../../../FilterLabel';
import { REQUIREMENT_TYPE_FILTERS, REQUIREMENT_TYPE_STATES } from '../../util/options';

function RequirementTypesFilters({ type, onChange, currentFilters, onReset, blueprint }) {
  const initRef = useRef();
  const dispatch = useDispatch();

  return (
    <Popover
      closeOnBlur={false}
      initalFocusRef={initRef}
      placement="left-start"
    >
      {({ isOpen, onClose }) => (
        <>
          <Tooltip fontSize="xs" label="Filter Templates">
            <Box>
              <PopoverTrigger>
                <IconButton
                  aria-label={`Filter ${type} Types`}
                  icon={<Icon as={BsFunnel} boxSize="24px" />}
                  variant="accent"
                />
              </PopoverTrigger>
            </Box>
          </Tooltip>
          <PopoverContent>
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader px={6} py={4} textAlign="left">
              <Text color="greyScale.900" textStyle="bodyXxl500">
                Filters
              </Text>
            </PopoverHeader>
            <PopoverBody pb={4} px={6} width="395px">
              <Box pb={3} pt={1}>
                <FilterLabel labelName="Show:" />
                <Flex flexFlow="column nowrap">
                  <Checkbox
                    isChecked={currentFilters?.defaults}
                    my={1}
                    spacing="1rem"
                    onChange={e => onChange(e.target.checked, REQUIREMENT_TYPE_FILTERS?.[type]?.Defaults)}
                  >
                    <Box as="span" color="greyScale.900">
                      {`Standard ${type}`}
                    </Box>
                  </Checkbox>
                  <Checkbox
                    isChecked={currentFilters?.customs}
                    my={1}
                    spacing="1rem"
                    onChange={e => onChange(e.target.checked, REQUIREMENT_TYPE_FILTERS?.[type]?.Customs)}
                  >
                    <Box as="span" color="greyScale.900">
                      {`Custom ${type}`}
                    </Box>
                  </Checkbox>
                </Flex>
              </Box>
              <HStack justifyContent="center" my={4} spacing={2}>
                <Button
                  variant="secondary"
                  onClick={() => {
                    dispatch(blueprint.resetFilters(REQUIREMENT_TYPE_STATES[type]));
                    onReset();
                  }}
                >
                  Clear Filters
                </Button>
                <Button onClick={() => onClose()}>ApplyFilters</Button>
              </HStack>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
}

RequirementTypesFilters.propTypes = {
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default RequirementTypesFilters;
